import React from 'react'
import { Route } from 'react-router'
import VisibleSearch from './containers/VisibleSearch'

const searchRoute = <Route path="/search" component={VisibleSearch} />
export default searchRoute



// WEBPACK FOOTER //
// ./src/domains/search/index.js